import { defineComponent as f, computed as l, createBlock as a, openBlock as r, unref as s, normalizeClass as i, withCtx as v, createElementVNode as h, createCommentVNode as p } from "vue";
import { RevButtonBase as g } from "@ds/components/ButtonBase";
import C from "../../../icons/generated/IconArrowDown.vue2.js";
import b from "../../../icons/generated/IconArrowUp.vue2.js";
import E from "../../../icons/generated/IconSort.vue2.js";
import { tw as e } from "../../../utils/tailwind.js";
const B = /* @__PURE__ */ f({
  __name: "TableSortingHeader",
  props: {
    value: {}
  },
  emits: ["change"],
  setup(t, { emit: c }) {
    const o = t, n = c, u = l(() => [
      e`ring-default-hi-color group rounded-sm size-32 p-4 hover:bg-action-default-min-hover`,
      o.value === "UNDEFINED" ? e`hover:bg-action-default-low-hover` : e`hover:bg-action-default-low-hoverpressed`
    ]), d = l(() => [
      e`rounded-xs flex size-24 items-center justify-center border`,
      o.value === "UNDEFINED" ? e`bg-action-default-low border-action-default-hi text-onaction-default-low group-hover:bg-action-default-low-hover` : e`bg-action-default-low-pressed border-action-default-hi-pressed text-onaction-default-low-pressed group-hover:bg-action-default-low-hoverpressed`
    ]), m = () => {
      o.value === "ASC" ? n("change", "DESC") : o.value === "DESC" ? n("change", "UNDEFINED") : n("change", "ASC");
    };
    return (N, D) => (r(), a(s(g), {
      class: i(u.value),
      onClick: m
    }, {
      default: v(() => [
        h("div", {
          class: i(d.value)
        }, [
          t.value === "ASC" ? (r(), a(s(b), {
            key: 0,
            "data-test": "icon-sort-asc",
            size: "16"
          })) : t.value === "DESC" ? (r(), a(s(C), {
            key: 1,
            "data-test": "icon-sort-desc",
            size: "16"
          })) : t.value === "UNDEFINED" ? (r(), a(s(E), {
            key: 2,
            "data-test": "icon-sort-null",
            size: "16"
          })) : p("", !0)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
});
export {
  B as default
};
